/**
 * Data fetch action creators for the claims dashboard.
 *
 * Split from claimsDashboardActionCreator.js for maintainability.
 */
import { makeApiCall } from '../../../../../services/apiService/apiService';

export const getClaimsPresignedUrlAction = (
  fileName,
  successCallback = () => {},
  failureCallback = () => {}
) => () => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getClaimsPresignedUrl',
    method: 'GET',
    replaceParamsArr: [{ key: 'fileName', val: fileName }],
    successCb: successCallback,
    failureCb: failureCallback,
    catchCb: failureCallback
  };
  return makeApiCall(requestObj);
};

export const getClaimById = (
  claimId,
  successCallback = () => {},
  failureCallback = () => {}
) => () => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getClaimById',
    method: 'GET',
    pathVariables: [{ key: '{id}', val: claimId }],
    successCb: successCallback,
    failureCb: failureCallback,
    catchCb: failureCallback
  };
  return makeApiCall(requestObj);
};

export const getClaimRcaData = (
  claimId,
  successCallback = () => {},
  failureCallback = () => {}
) => () => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getClaimRcaData',
    method: 'GET',
    pathVariables: [{ key: '{id}', val: claimId }],
    successCb: successCallback,
    failureCb: failureCallback,
    catchCb: failureCallback
  };
  return makeApiCall(requestObj);
};

export const getClaimAckData = (
  claimId,
  successCallback = () => {},
  failureCallback = () => {}
) => () => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getClaimAckData',
    method: 'GET',
    pathVariables: [{ key: '{id}', val: claimId }],
    successCb: successCallback,
    failureCb: failureCallback,
    catchCb: failureCallback
  };
  return makeApiCall(requestObj);
};

export const getClaimStatusHistory = (
  claimId,
  successCallback = () => {},
  failureCallback = () => {}
) => () => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getClaimStatusHistory',
    method: 'GET',
    pathVariables: [{ key: '{id}', val: claimId }],
    successCb: successCallback,
    failureCb: failureCallback,
    catchCb: failureCallback
  };
  return makeApiCall(requestObj);
};

export const fetchCnoteDetails = (
  cnote,
  successCallback = () => {},
  failureCallback = () => {}
) => () => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'validateCnoteAndFetch',
    method: 'GET',
    params: { cnote },
    successCb: successCallback,
    failureCb: failureCallback,
    catchCb: failureCallback
  };
  return makeApiCall(requestObj);
};

export const getClaimReassignEligibility = (
  claimId,
  successCallback = () => {},
  failureCallback = () => {}
) => () => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'claimReassignEligibility',
    method: 'GET',
    pathVariables: [{ key: '{id}', val: claimId }],
    successCb: successCallback,
    failureCb: failureCallback,
    catchCb: failureCallback
  };
  return makeApiCall(requestObj);
};

export const getSamKamMappings = (
  successCallback = () => {},
  failureCallback = () => {}
) => () => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'samKamMappings',
    method: 'GET',
    successCb: successCallback,
    failureCb: failureCallback,
    catchCb: failureCallback
  };
  return makeApiCall(requestObj);
};

export const getClientCodes = (
  successCallback = () => {},
  failureCallback = () => {}
) => () => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getClientCodes',
    method: 'GET',
    successCb: successCallback,
    failureCb: failureCallback,
    catchCb: failureCallback
  };
  return makeApiCall(requestObj);
};

export const getClientIdToCodeMap = (
  successCallback = () => {},
  failureCallback = () => {}
) => () => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getClientIdToCodeMap',
    method: 'GET',
    successCb: successCallback,
    failureCb: failureCallback,
    catchCb: failureCallback
  };
  return makeApiCall(requestObj);
};

export const getLocationCodeIdMap = (
  locationTypes,
  successCallback = () => {},
  failureCallback = () => {}
) => () => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getLocationCodeIdMap',
    method: 'GET',
    replaceParamsArr: [{ key: 'locationTypes', val: locationTypes }],
    successCb: successCallback,
    failureCb: failureCallback,
    catchCb: failureCallback
  };
  return makeApiCall(requestObj);
};

export const refreshCreditNote = (
  cnote,
  successCallback = () => {},
  failureCallback = () => {}
) => () => {
  const requestObj = {
    baseUrl: 'zoomBillingUrl',
    apiEndPoint: 'refreshCreditNote',
    method: 'GET',
    pathVariables: [{ key: '{cnote}', val: cnote }],
    successCb: successCallback,
    failureCb: failureCallback,
    catchCb: failureCallback
  };
  return makeApiCall(requestObj);
};
